import { async } from '@angular/core/testing';
import { Component, OnInit, TemplateRef, enableProdMode, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, FormsModule, Form } from '@angular/forms';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { CampaignService } from './../campaign.service';
import { ProviderService } from './../../provider/provider.service';
import { Campaign } from './../campaign.model';
import { sortBy, get, lowerCase, includes, chain } from 'lodash';
import { BsModalService, TimepickerModule } from 'ngx-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { unescape } from 'lodash';
import { Encoder } from '../../../utils/encoder';
import { Provider } from './../../provider/provider.model';
import { ProviderListResponse } from './../../provider/provider-list-reponse.model';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { providerDef } from '@angular/core/src/view';
import { isObject } from 'util';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Client } from '../../client/client.model';
import { htmlToText } from 'html-to-text';
import { CognitoService } from '../../../services/cognito/cognito.service';
enableProdMode();

@Component({
  selector: 'app-campaign',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class CampaignFormComponent implements OnInit,OnDestroy {
  campaignForm: FormGroup;
  provider: FormControl;
  id: FormControl;
  name: FormControl;
  description: FormControl;
  country: FormControl;
  timezone: FormControl;
  currencyCode: FormControl;
  brandName: FormControl;
  skuType: FormControl;
  grossBuget: FormControl;
  startDate: FormControl;
  endDate: FormControl;
  costBasic: FormControl;
  costValue: FormControl;
  objective: FormControl;
  objectiveValue: FormControl;
  ageFrom: FormControl;
  ageTo: FormControl;
  currencyFrom: FormControl;
  currencyTo: FormControl;
  gender: FormControl;
  impAttri: FormControl;
  asGroup: FormControl;
  collectSample: FormControl;
  receiveFromCds2: FormControl;
  sendToCds2: FormControl;
  clientId: FormControl;
  segment: FormControl;
  segmentCategory: FormControl;
  forever: FormControl;
  apiKey: FormControl;
  campaignType: FormControl;
  pinpoint: FormControl;

  email: FormControl;
  phone: FormControl;
  sms: FormControl;
  whatsapp: FormControl;
  body: FormControl;
  subject: FormControl;
  experienceName: FormControl;
  modalRef: BsModalRef;
  timeZoneList: Array<string>;
  currencyCodeList: Array<string>;

  PrizeImage: FormControl;
  PrizeRenderImage: FormControl;
  BannerImage: FormControl;
  BannerRenderImage: FormControl;
  CampaignImage: FormControl;
  CampaignRenderImage: FormControl;
  Flag: FormControl;
  userTerm: FormControl;
  privacyPolicy: FormControl;
  NGPSConfigurationId: FormControl;

  regionList: Array<any>;
  countryList: Array<any>;
  buList: Array<any>;
  partyList: Array<string>;
  providerList: Array<Provider>;
  genderList: Array<string>
  filteredProviders: Observable<Provider[]>;
  filteredTimeZones: Observable<String[]>;
  isAsGroup: boolean;
  isCollectSample: boolean;
  isReceiveFromCds2: boolean;
  isSendToCds2: boolean;

  showAlert = false;
  errorMessage: string = null;

  campaign: Campaign = new Campaign();
  isEditing: boolean;

  client: Client;
  createdCampaignId: string;
  deleteModalRef: BsModalRef;
  loading: boolean = false;
  judgeDateValue: boolean = false;
  foreverEnd: boolean = false;
  viewCode: boolean = true;
  cokieCode: string;
  verifiSave: boolean;
  ifDateRequire: boolean;
  segmentCatList: Array<any> = [];
  segmentList: Array<any> = [];

  brandList: any;
  cookieBrandList: any;

  htmlStrValidate: string = '';
  isEmail: boolean;
  isPhone: boolean;
  isSms: boolean;
  isWhatsapp: boolean;
  subjectContent: string;
  emailTemplateHtmlContent: string;
  emailTemplateTextContent: string;
  editor: any;

  currentTab: string = 'CDS';
  isOnlyDashVisible: boolean = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private campaignService: CampaignService,
    private modalService: BsModalService,
    private cognitoService: CognitoService,
  ) { }

  ngOnDestroy(): void {
    tinymce.remove("#body");
  }

  ngOnInit() {
    this.getBrandList();
    this.createFormControls();
    this.createForm();
    this.getSegmentList();
    this.isOnlyDashVisible = !this.cognitoService.isDashRole();
    this.id.disable();
    this.campaignType.setValue('1');
    this.collectSample.setValue(true);
    this.campaignService.hasJustRegistered = false;
    //const data: Object = {};

    const data = get(this.activatedRoute, ['snapshot', 'data'], {});

    this.partyList = this.getPartiesList();
    this.providerList = this.getProviderList();
    this.campaignService.getTimeZoneList()
      .subscribe((timeZoneList) => {
        this.timeZoneList = timeZoneList;
        this.filteredTimeZones = this.timezone.valueChanges
          .pipe(
            startWith<string>(''),
            map(name => name ? this.filterTimeZone(name) : this.timeZoneList.slice())
          );
      });
    this.campaignService.getCurrencyCodeList()
      .subscribe((currencyCodeList) => {
        this.currencyCodeList = currencyCodeList;
      });
    this.filteredProviders = this.provider.valueChanges
      .pipe(
        startWith<string | Provider>(''),
        map(value => typeof value === 'string' ? value : value.providerName),
        map(name => name ? this.filterProvider(name) : this.providerList.slice())
      );

    this.genderList = this.campaignService.getGenderList();
    this.campaignService.getRegionList()
      .subscribe((regions) => {
        this.regionList = regions;

        var i = 0;
        var buDatas = new Array();
        for (i; i < this.regionList.length; i++) {
          var buData = new Array();
          buData = this.regionList[i].bu;
          var j = 0;
          for (j; j < buData.length; j++) {
            buDatas.push(buData[j]);
          }
        }
        i = 0;
        var countryDatas = new Array();
        for (i; i < buDatas.length; i++) {
          var countryData = new Array();
          countryData = buDatas[i].country;
          var j = 0;
          for (j; j < countryData.length; j++) {
            countryDatas.push(countryData[j]);
          }
        }
        this.countryList = countryDatas;
        // this.country.setValue(this.countryList[0].code);
        this.onChangeCountry(0);
        if (this.isEditing) {
          this.country.setValue(this.campaign.campaignMainCountry);
        }
      });
      // @ts-ignore
      this.isEditing = data.campaign;

      if (this.isEditing) {
        // this.provider.disable();
        this.clientId.disable();
        // @ts-ignore
        this.campaign = data.campaign;
        if (this.campaign.hasOwnProperty('campaignId')) {
          this.setValueOnForm();
          this.providerList.forEach((provider) => {
            if (provider.providerId == this.campaign.providerId) {
              this.provider.setValue(provider);
            }
          });
          this.experienceName.setValue(this.getExperienceName());
        } else {
          this.router.navigate(['/campaigns']);
        }
      }
  }

  changeTab(tab: string) {
    this.currentTab = tab;
  }

  onChangeCountry(countryIndex: number) {
  }

  onFileSelected(event,type: string) {  
    this.loading = true;
    const curFile = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      const base64String = reader.result as string;
      const params:any = {
        fileName: curFile.name,
        fileContent: base64String.split(',')[1],
        contentType: curFile.type,
      }
      this.campaignService.uploadImage(params).subscribe(res => {
        if (res) {
          const Map:any = {
            PrizeImage: () => {
              this.PrizeRenderImage.setValue(res.data)
            },
            BannerImage: () => {
              this.BannerRenderImage.setValue(res.data)
            },
            CampaignImage: () => {
              this.CampaignRenderImage.setValue(res.data)
            }
          }
          Map[type]();
        }
      })
      // 将base64String发送到服务器
    };
    reader.readAsDataURL(curFile)
  }
  onImageLoad() {
    this.loading = false;
  }

  deleteImage(type: string){
    const Map:any = {
      PrizeImage: () => {
        this.PrizeImage.setValue(null)
        this.PrizeRenderImage.setValue('')
      },
      BannerImage: () => {
        this.BannerImage.setValue(null)
        this.BannerRenderImage.setValue('')
      },
      CampaignImage: () => {
        this.CampaignImage.setValue(null)
        this.CampaignRenderImage.setValue('')
      }
    }
    Map[type]();
  }
  getBrandList() {
    this.campaignService.getBrandList().subscribe(res => {
      if (res) {
        this.brandList = res;
        this.brandList = this.brandList.sort();
        this.cookieBrandList = JSON.parse(JSON.stringify(this.brandList));
      }
    })
  }

  getExperienceName() {
    if (this) {
      return `${this.provider.value.region}_${this.provider.value.bu}_${this.provider.value.country}_${this.campaign.campaignId}`;
    }
    return undefined;
  }

  setValueOnForm() {
    this.campaignService.getClientById(this.campaign.campaignId)
      .subscribe((clients) => {
        if (clients[0]) {
          this.cokieCode = clients[0].apiKey;
          this.apiKey.setValue('*********************');
          this.client = clients[0];
          if (this.client) {
            this.clientId.setValue(this.client.clientId);
          }
        }
      });
    this.id.setValue(this.campaign.campaignId);
    this.name.setValue(Encoder.decode(this.campaign.campaignName));
    this.description.setValue(Encoder.decode(this.campaign.campaignDesc));
    this.country.setValue(this.campaign.campaignMainCountry);
    this.timezone.setValue(this.campaign.campaignTimeZone);
    this.currencyCode.setValue(this.campaign.campaignCurrencyCode);
    this.brandName.setValue(Encoder.decode(this.campaign.brandName));
    this.skuType.setValue(Encoder.decode(this.campaign.skuType));
    this.grossBuget.setValue(this.campaign.campaignGrossBudget ? Number(this.campaign.campaignGrossBudget) : null);
    this.startDate.setValue(this.campaign.campaignStartDt ? this.getLocalDate(this.campaign.campaignStartDt * 1000) : null);
    this.endDate.setValue(this.campaign.campaignEndDt ? this.getLocalDate(this.campaign.campaignEndDt * 1000) : null);
    this.costBasic.setValue(this.campaign.campaignCostBasis ? Number(this.campaign.campaignCostBasis) : null);
    this.costValue.setValue(this.campaign.campaignCostValue ? Number(this.campaign.campaignCostValue) : null);
    this.objective.setValue(Encoder.decode(this.campaign.campaignObjective));
    this.objectiveValue.setValue(this.campaign.campaignObjectiveValue ? Number(this.campaign.campaignObjectiveValue) : null);
    this.ageFrom.setValue(this.campaign.targetingAgeFrom ? Number(this.campaign.targetingAgeFrom) : null);
    this.ageTo.setValue(this.campaign.targetingAgeTo ? Number(this.campaign.targetingAgeTo) : null);
    this.currencyFrom.setValue(this.campaign.targetingIncomeCurrencyFrom ? Number(this.campaign.targetingIncomeCurrencyFrom) : null);
    this.currencyTo.setValue(this.campaign.targetingIncomeCurrencyTo ? Number(this.campaign.targetingIncomeCurrencyTo) : null);
    this.gender.setValue(this.campaign.targetingGender);
    this.impAttri.setValue(this.campaign.campaignImpressionAttributionWindow ? Number(this.campaign.campaignImpressionAttributionWindow) : null);
    this.segment.setValue(this.campaign.segment);
    this.segmentCategory.setValue(this.campaign.segmentCategory);
    this.pinpoint.setValue(this.campaign.pinpoint);
    this.campaignType.setValue(this.campaign.campaignType);
    this.asGroup.setValue((String(this.campaign['marketedAsGroup']) == 'true'));
    this.collectSample.setValue((String(this.campaign['isCollectSample']) == 'true'));
    this.receiveFromCds2.setValue((String(this.campaign['isReceiveFromCds2']) == 'true'));
    this.sendToCds2.setValue((String(this.campaign['isSendToCds2']) == 'true'));
    this.email.setValue((String(this.campaign['isEmail']) == 'true'));
    this.phone.setValue((String(this.campaign['isPhone']) == 'true'));
    this.sms.setValue((String(this.campaign['isSms']) == 'true'));
    this.whatsapp.setValue((String(this.campaign['isWhatsapp']) == 'true'));
    this.subject.setValue(this.campaign['subjectContent']);
    this.body.setValue(this.campaign['emailTemplateHtmlContent']);
    this.PrizeRenderImage.setValue(this.campaign.prizeUrl)
    this.BannerRenderImage.setValue(this.campaign.bannerUrl)
    this.CampaignRenderImage.setValue(this.campaign.iconUrl)
    this.Flag.setValue(this.campaign.onlyDash === 'true' ? true: false)
    this.userTerm.setValue(this.campaign.userTerm)
    this.privacyPolicy.setValue(this.campaign.privacyPolicy)
    this.NGPSConfigurationId.setValue(this.campaign.ngpsCfgId)
    if (!this.endDate.value) {
      this.foreverEnd = true;
      this.endDate.disable();
    }
    this.pushSegmentData(this.segmentCatList);
  }

  getLocalDate(time) {
    let date = new Date(time);
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    return new Date(year, month, day);
  }

  filterProvider(name: string): Provider[] {
    return this.providerList.filter(option =>
      option.providerName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  filterTimeZone(name: string): String[] {
    return this.timeZoneList.filter(option =>
      option.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }

  private getPartiesList(): Array<string> {
    return get(this.activatedRoute, ['snapshot', 'data', 'parties'], []);
  }

  private getProviderList(): Array<Provider> {
    let res: ProviderListResponse = get(this.activatedRoute, ['snapshot', 'data', 'providers'], [])
    return res.items;
  }

  displayProvider(provider?: Provider): string | undefined {
    return provider ? provider.providerName : undefined;
  }

  providerValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    let exist = false;
    const value = control.value;
    if (!value) {
      return null;
    }
    if (isObject(value)) {
      return null;
    }
    if (this.providerList) {
      this.providerList.forEach(providerOpt => {
        if (providerOpt.providerName == value) {
          this.provider.setValue(providerOpt);
          exist = true;
        }
      });
    }
    return !exist ? { 'invalid': true } : null;
  };

  integerValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }
    return ((parseFloat(value) == parseInt(value)) && !isNaN(value)) ? null : { 'integer': true };
  };

  createFormControls() {
    this.provider = new FormControl('', {
      validators: [Validators.required, this.providerValidator]
    });
    this.id = new FormControl('');
    this.name = new FormControl('', {
      validators: Validators.required
    });
    this.description = new FormControl('');
    this.country = new FormControl('',{
      validators: Validators.required
    });
    this.timezone = new FormControl('');
    this.currencyCode = new FormControl('');
    this.brandName = new FormControl('');
    this.skuType = new FormControl('');
    this.grossBuget = new FormControl('');
    this.startDate = new FormControl('', {
      validators: Validators.required
    });
    this.endDate = new FormControl('');
    this.costBasic = new FormControl('');
    this.costValue = new FormControl('');
    this.objective = new FormControl('');
    this.objectiveValue = new FormControl('');
    this.ageFrom = new FormControl('', {
      validators: this.integerValidator
    });
    this.ageTo = new FormControl('', {
      validators: this.integerValidator
    });
    this.currencyFrom = new FormControl('');
    this.currencyTo = new FormControl('');
    this.gender = new FormControl('');
    this.impAttri = new FormControl('', {
      validators: this.integerValidator
    });
    this.segment = new FormControl('');
    this.segmentCategory = new FormControl('');
    this.costBasic = new FormControl('');
    this.asGroup = new FormControl('');
    this.collectSample = new FormControl('');
    this.receiveFromCds2 = new FormControl('');
    this.sendToCds2 = new FormControl('');
    this.clientId = new FormControl('');
    this.forever = new FormControl('');
    this.apiKey = new FormControl('');
    this.campaignType = new FormControl('');
    this.pinpoint = new FormControl('');
    this.email = new FormControl('');
    this.phone = new FormControl('');
    this.sms = new FormControl('');
    this.whatsapp = new FormControl('');
    this.subject = new FormControl('');
    this.body = new FormControl('');
    this.experienceName = new FormControl('');

    this.PrizeImage = new FormControl('');
    this.PrizeRenderImage = new FormControl('');
    this.BannerImage = new FormControl('');
    this.BannerRenderImage = new FormControl('');
    this.CampaignImage = new FormControl('');
    this.CampaignRenderImage = new FormControl('');
    this.Flag = new FormControl(false);
    this.userTerm = new FormControl('');
    this.privacyPolicy = new FormControl('');
    this.NGPSConfigurationId = new FormControl('');
  }

  createForm() {
    this.campaignForm = new FormGroup({
      provider: this.provider,
      id: this.id,
      name: this.name,
      country: this.country,
      description: this.description,
      timezone: this.timezone,
      currencyCode: this.currencyCode,
      brandName: this.brandName,
      skuType: this.skuType,
      grossBuget: this.grossBuget,
      startDate: this.startDate,
      endDate: this.endDate,
      costBasic: this.costBasic,
      costValue: this.costValue,
      objective: this.objective,
      objectiveValue: this.objectiveValue,
      ageFrom: this.ageFrom,
      ageTo: this.ageTo,
      currencyFrom: this.currencyFrom,
      currencyTo: this.currencyTo,
      gender: this.gender,
      impAttri: this.impAttri,
      segmentCategory: this.segmentCategory,
      segment: this.segment,
      asGroup: this.asGroup,
      collectSample: this.collectSample,
      receiveFromCds2: this.receiveFromCds2,
      sendToCds2: this.sendToCds2,
      clientId: this.clientId,
      forever: this.forever,
      apiKey: this.apiKey,
      campaignType: this.campaignType,
      pinpoint: this.pinpoint,
      email: this.email,
      phone: this.phone,
      sms: this.sms,
      whatsapp: this.whatsapp,
      subject: this.subject,
      PrizeImage: this.PrizeImage,
      PrizeRenderImage: this.PrizeRenderImage,
      BannerImage: this.BannerImage,
      BannerRenderImage: this.BannerRenderImage,
      CampaignImage: this.CampaignImage,
      CampaignRenderImage: this.CampaignRenderImage,
      Flag: this.Flag,
      userTerm: this.userTerm,
      privacyPolicy: this.privacyPolicy,
      NGPSConfigurationId: this.NGPSConfigurationId,
      body: this.body,
      experienceName: this.experienceName
    });
  }

  getCampaignFromFrom() {
    const campaign = new Campaign();
    campaign.campaignName = Encoder.encode(this.name.value);
    campaign.campaignDesc = Encoder.encode(this.description.value) || null;
    campaign.campaignMainCountry = Encoder.encode(this.country.value) || null;
    campaign.campaignTimeZone = this.timezone.value || null;
    campaign.campaignCurrencyCode = this.currencyCode.value || null;
    campaign.brandName = this.brandName.value || null;
    campaign.skuType = Encoder.encode(this.skuType.value) || null;
    campaign.campaignGrossBudget = this.grossBuget.value || null;
    campaign.campaignStartDt = this.startDate.value ? this.GetUTCDateTimestamp(this.startDate.value) : null;
    campaign.campaignEndDt = this.endDate.value ? this.GetUTCDateTimestamp(this.endDate.value) : null;
    campaign.campaignCostBasis = this.costBasic.value || null;
    campaign.campaignCostValue = this.costValue.value || null;
    campaign.campaignObjective = Encoder.encode(this.objective.value) || null;
    campaign.campaignObjectiveValue = this.objectiveValue.value || null;
    campaign.targetingAgeFrom = this.ageFrom.value || null;
    campaign.targetingAgeTo = this.ageTo.value || null;
    campaign.targetingIncomeCurrencyFrom = this.currencyFrom.value || null;
    campaign.targetingIncomeCurrencyTo = this.currencyTo.value || null;
    campaign.targetingGender = this.gender.value || null;
    campaign.campaignImpressionAttributionWindow = this.impAttri.value || null;
    campaign.marketedAsGroup = this.asGroup.value || false;
    campaign.isCollectSample = this.collectSample.value || false;
    campaign.isReceiveFromCds2 = this.receiveFromCds2.value || false;
    campaign.isSendToCds2 = this.sendToCds2.value || false;
    campaign.providerId = this.provider.value.providerId;
    campaign.segment = this.segment.value || null;
    campaign.segmentCategory = this.segmentCategory.value || null;
    campaign.createTime = Math.floor(Date.now() / 1000);
    campaign.campaignType = this.campaignType.value || null;
    campaign.pinpoint = this.pinpoint.value || null;
    campaign.isEmail = this.email.value || false;
    campaign.isPhone = this.phone.value || false;
    campaign.isSms = this.sms.value || false;
    campaign.isWhatsapp = this.whatsapp.value || false;
    campaign.subjectContent = this.subject.value || null;
    campaign.emailTemplateHtmlContent = null;
    campaign.emailTemplateTextContent = null;
    campaign.iconUrl = this.CampaignRenderImage.value || null;
    campaign.bannerUrl = this.BannerRenderImage.value || null;
    campaign.prizeUrl = this.PrizeRenderImage.value || null;
    campaign.onlyDash = this.Flag.value || false;
    campaign.userTerm = this.userTerm.value || null;
    campaign.privacyPolicy = this.privacyPolicy.value || null;
    campaign.ngpsCfgId = this.NGPSConfigurationId.value || null;

    if (tinymce.activeEditor.getContent() != null && tinymce.activeEditor.getContent() != "") {
      let tinymceValue = tinymce.activeEditor.getContent().replaceAll(">\n", ">\\n");
      campaign.emailTemplateHtmlContent = tinymceValue.replaceAll(">\r", ">\\r");
      let emailTemplateTextContent = htmlToText(tinymce.activeEditor.getContent(), {
        wordwrap: false
      });

      emailTemplateTextContent = emailTemplateTextContent.replaceAll("\n", "\\n");
      campaign.emailTemplateTextContent = emailTemplateTextContent.replaceAll("\r", "\\r");
    }

    if (this.isEditing) {
      campaign.createTime = Math.floor(this.campaign.createTime / 1);
      this.activatedRoute.params.subscribe(value => {
        campaign.campaignId = value.campaignId;
      });
      if (this.client) {
        campaign.clientId = this.client.clientId;
      }
    }
    this.providerList.forEach(item => {
      if (item.providerId == campaign.providerId) {
        campaign.providerDetail = item;
      }
    });
    return campaign;
  }

  GetUTCDateTimestamp(time) {
    const date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth();
    let day = date.getDate();
    return Math.floor(Date.UTC(year, month, day) / 1000);
  }

  campaignSubmit(template: TemplateRef<any>): any {
    this.htmlStrValidate = this.checkHtml(this.name.value) ? 'campaignName' : this.checkHtml(this.description.value) ? 'description' :
      this.checkHtml(this.skuType.value) ? 'skuType' : this.checkHtml(this.objective.value) ? 'objective' : ''

    if (this.htmlStrValidate !== '') return null
    if (this.timezone.value != '' && !this.verifiSave) {
      return false;
    }
    if (!this.foreverEnd && (!this.endDate.value || !this.startDate.value)) {
      this.ifDateRequire = true;
      return false;
    }
    if (this.startDate.value && this.endDate.value) {
      let start = new Date(this.startDate.value).getTime();
      let end = new Date(this.endDate.value).getTime();
      if (start > end) {
        this.judgeDateValue = true;
        return;
      }
    }
    this.ifDateRequire = false;

    this.dirtyForm(this.campaignForm);

    if (this.campaignForm.valid) {
      const campaign = this.getCampaignFromFrom();
      this.transformSegment(campaign);
      this.loading = true;
      this.campaignService.saveCampaign(campaign)
        .subscribe(res => {
          this.loading = false;
          this.createdCampaignId = res.data.campaignId;
          // res.data.clientId;
          if (!this.isEditing) {
            this.modalRef = this.modalService.show(template, {
              ignoreBackdropClick: true
            });
          } else {
            this.router.navigate(['/campaigns']);
          }
        }, error => {
          this.loading = false;
          this.showAlert = true;
          this.errorMessage = error;
        });
    }
  }

  transformSegment(campaign) {
    let arrSegment = [], arrSegmentCat = [];
    const findData = (validation, list, arr) => {
      validation.split(',').forEach(result => {
        const data = list.find(segment => segment.segment_name == result);
        if (data) {
          arr.push(data.segment_value);
        }
      });
    }
    findData(this.segment.value, this.segmentList, arrSegment);
    findData(this.segmentCategory.value, this.segmentCatList, arrSegmentCat);
    if (arrSegment.length) {
      campaign.segment = arrSegment.toString();
    }
    if (arrSegmentCat.length) {
      campaign.segmentCategory = arrSegmentCat.toString();
    }
  }

  navigateToEdit() {
    this.router.navigate(['/campaigns/edit', { campaignId: this.createdCampaignId }]);
  }

  errorMessageClose(): void {
    this.showAlert = false;
    this.errorMessage = '';
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() =>
        this.router.navigate([uri]));
  }


  deleteShowModal(template: TemplateRef<any>): any {
    this.deleteModalRef = this.modalService.show(template, {
      ignoreBackdropClick: true
    });
  }

  deleteConfirm() {
    this.activatedRoute.params.subscribe(value => {
      this.loading = true;
      this.campaignService.deleteClientById(this.client.clientId).subscribe(res => { }, error => { });
      this.campaignService.deleteCampaignById(value.campaignId).subscribe(res => {
        this.loading = false;
        this.router.navigate(['/campaigns']);
        this.deleteModalRef.hide()
      }, error => {
        this.loading = false;
        this.deleteModalRef.hide()
        this.showAlert = true;
        this.errorMessage = error;
      });
    })
  }

  private dirtyForm(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {
      const control = form.controls[key];

      if (control instanceof FormGroup) {
        return this.dirtyForm(control);
      }

      control.markAsDirty();
    });
  }

  verifiData(data) {
    if (this.timeZoneList) {
      this.verifiSave = false;
      this.timeZoneList.forEach(el => {
        if (el == data) {
          this.verifiSave = true;
        }
      })
    } else {
      this.verifiSave = true;
    }
  }

  judgeDate(bol, source) {
    let date = source.target.value;
    const curryDate = new Date(date).getTime();
    if (bol) {
      let endValue = this.endDate.value;
      let end = new Date(endValue).getTime();
      !isNaN(end) && curryDate > end ? this.judgeDateValue = true : this.judgeDateValue = false;
    } else {
      let startValue = this.startDate.value;
      let start = new Date(startValue).getTime();
      !isNaN(curryDate) && start > curryDate ? this.judgeDateValue = true : this.judgeDateValue = false;
    }
  }

  isForevry() {
    if (this.foreverEnd) {
      this.endDate.setValue('');
      this.ifDateRequire = false;
    }
    this.judgeDateValue = false;
  }

  showApiKey() {
    if (this.viewCode) {
      this.apiKey = new FormControl(this.cokieCode);
      this.viewCode = !this.viewCode;
    } else {
      this.cokieCode = this.apiKey.value;
      this.apiKey = new FormControl('*****************');
      this.viewCode = !this.viewCode;
    }
  }

  shooseBrand(data) {
    if (this.brandName.value.indexOf(data) > -1) {
      return false;
    }
    const comma = this.brandName.value ? ',' : '';
    const brandValue = `${this.brandName.value}${comma}${data}`;
    this.brandName.setValue(brandValue);
  }

  noInputBrand(e: any) {
    if (e.keyCode != '8') {
      this.brandList.sort((a) => {
        return a[0] == e.key.toUpperCase() ? -1 : 1;
      });
      return false;
    }
    const index = this.brandName.value.lastIndexOf(',');
    const brandValue = this.brandName.value.substring(0, index + 1);
    this.brandName.setValue(brandValue);

  }

  private getSegmentList() {
    const list: Array<any> = JSON.parse(localStorage.getItem('segmentList'));
    const getAllData = () => {
      this.campaignService.getSegmentList().subscribe(res => {
        this.segmentCatList = this.segmentCatList.concat(res['items']);
        if (res['nextPageKey']) {
          getAllData();
        } else {
          this.segmentCatList = this.segmentCatList.filter(result => {
            if (!result.parent) {
              result.son = [];
              this.segmentCatList.forEach(value => {
                if (value.parent == result.segment_value) {
                  result.son.push(value);
                }
              })
              return result;
            }
          })
        }
        localStorage.setItem('segmentList', JSON.stringify(this.segmentCatList));
      })
    }
    if (list) {
      this.segmentCatList = list;
      return;
    }
    getAllData();
  }

  pushSegmentData(list) {
    if (this.segmentCategory.value) {
      const catList = [];
      const arr = this.segmentCategory.value.split(',');
      list.forEach(data => {
        const result = arr.find(segment => segment == data.segment_value);
        if (result) {
          catList.push(data.segment_name);
          this.segmentList = this.segmentList.concat(data.son);
        }
      });
      if (catList.length) {
        this.segmentCategory.setValue(catList.toString());
      }
    }
    if (this.segment.value) {
      const arr = this.segment.value.split(',');
      const segList = [];
      this.segmentList.forEach(data => {
        const result = arr.find(segment => segment == data.segment_value);
        if (result) {
          segList.push(data.segment_name);
        }
      });
      if (segList.length) {
        this.segment.setValue(segList.toString());
      }
    }
  }

  selectSegment(list, type) {
    const selectType = type ? this.segmentCategory : this.segment;
    if (type) {
      this.segmentList = this.segmentList.concat(list.son);
    }

    if (selectType.value.indexOf(list.segment_name) > -1) {
      return false;
    }
    const comma = selectType.value ? ',' : '';
    const value = `${selectType.value}${comma}${list.segment_name}`;
    selectType.setValue(value);
  }

  noInputSegment(e, type) {
    const selectType = type ? this.segmentCategory : this.segment;
    const list = type ? this.segmentCatList : this.segmentList;
    if (e.keyCode != '8') {
      list.sort((a) => {
        return a.segment_name[0] == e.key.toUpperCase() ? -1 : 1;
      });
      return false;
    }
    const index = selectType.value.lastIndexOf(',');
    if (type) {
      //delete the field which was typed
      const name = selectType.value.substring(index + 1, selectType.value.length);
      const deleteList = this.segmentCatList.find(result => result.segment_name == name);
      let valueList = this.segment.value.split(',');
      valueList = valueList.filter(name => {
        if (!deleteList.son.find(result => result.segment_name == name)) {
          return name
        }
      });
      this.segment.setValue(valueList.join(','));
      //delete the same list
      this.segmentList = this.segmentList.filter(segment => {
        const data = deleteList.son.find(result => result.segment_value == segment.segment_value);
        if (!data) {
          return segment;
        }
      });
    }
    const value = selectType.value.substring(0, index + 1);
    selectType.setValue(value);
  }

  checkHtml(htmlStr: string): boolean {
    let reg = /<[^>]+>/g;
    return reg.test(htmlStr);
  }

  checkInputValue(e) {
    return this[e.target.id].value = e.target.value = e.target.value.replace(/[^a-zA-Z0-9_\- ]||/g, '');
  }

  checkInputValueOther(e){
    return this[e.target.id].value = e.target.value;
  }
  ngAfterViewInit() {
    if (this.editor) return;
    tinymce.init({
      selector: '#body',
      plugins: [
        'advlist autolink lists link charmap print preview hr anchor pagebreak media',
        'searchreplace wordcount visualblocks visualchars code fullscreen ',
        'insertdatetime nonbreaking save table contextmenu directionality ',
        'paste textcolor colorpicker textpattern'
      ],
      height:"380",
      image_advtab: true,
      menubar: true
    });

  }

  getTabDashStyles() {
    if (this.isOnlyDashVisible) {
      return {
        'border-right': 'none',
      };
    } else {
      return {
        'border-top-right-radius': '5px',
      };
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/form/form.component.ts